import { map } from 'lodash-es';
import { generatePath } from 'react-router';

import AdminConsoleSideMenu from '../components/AdminConsoleSideMenu';
import {
  ADMIN_ACCOUNT_SECTIONS,
  getSectionRoute,
} from './adminAccountSections';

export default function AdminAccountSidebar({ accountNumber }) {
  const items = map(ADMIN_ACCOUNT_SECTIONS, section => ({
    labelId: section.labelId,
    to: generatePath(getSectionRoute(section), { accountNumber }),
  }));

  return <AdminConsoleSideMenu items={items} />;
}
